<template>
  <v-sheet rounded class="py-2 px-6 mb-1">
    <v-row row wrap>
      <v-col :xs="12" :lg="12" class="pb-0">
        <p class="body-1 font-weight-bold mb-0 navy--text text--darken-1">
          Zahrnutá místa
        </p>
      </v-col>

      <v-col lg="12" class="pb-0">
        <geo-location-type v-model="geoLocationsTypes"></geo-location-type>
      </v-col>

      <v-col
        v-for="(geoLocation, index) in geoLocations"
        :key="`geo-location-${index}`"
        lg="12"
        class="pb-0"
      >
        <geo-location-input
          :value="geoLocation"
          @delete="geoLocationRemove"
          @change="geoLocationUpdate"
        ></geo-location-input>
      </v-col>

      <v-col v-show="geoLocationSearchVisible">
        <geo-location-search
          @delete="onGeoLocationSearchDelete"
          @select="onGeoLocationSearchSelect"
          :visible="geoLocationSearchVisible"
        ></geo-location-search>
      </v-col>

      <v-col v-if="!geoLocationSearchVisible" lg="12">
        <v-btn
          text
          small
          class="navy--text text--darken-1 ml-n2"
          @click="geoLocationSearchVisible = true"
        >
          <img class="mr-2" :src="require('@/assets/ico-add.svg')" alt="" />
          Zahrnout další místo
        </v-btn>
      </v-col>

      <v-col lg="12" v-show="!excludedGeoLocationVisible">
        <v-btn
          @click="excludedGeoLocationVisible = true"
          text
          small
          class="navy--text text--darken-1 ml-n2"
        >
          <img class="mr-2" :src="require('@/assets/ico-minus.svg')" alt="" />
          Vyloučit místo
        </v-btn>
      </v-col>
    </v-row>

    <template v-if="excludedGeoLocationVisible">
      <v-row row wrap>
        <v-col sm="12" class="pb-0">
          <p class="body-1 font-weight-bold mb-0 navy--text text--darken-1">
            Vyloučená místa
          </p>
        </v-col>

        <v-col lg="12" class="pt-0">
          <v-row row wrap>
            <v-col
              lg="12"
              v-for="(geoLocation, index) in excludedGeoLocations"
              :key="'exludedPlace-' + index"
              class="pb-0"
            >
              <geo-location-input
                :value="geoLocation"
                @delete="excludedGeoLocationRemove"
                @change="excludedGeoLocationUpdate"
              ></geo-location-input>
            </v-col>
          </v-row>

          <geo-location-search
            @delete="onExcludedGeoLocationSearchDelete"
            @select="onExcludedGeoLocationSearchSelect"
            :visible="excludedGeoLocationSearchVisible"
          ></geo-location-search>
        </v-col>

        <v-col lg="12">
          <v-btn
            text
            small
            class="navy--text text--darken-1 ml-n2"
            @click="excludedGeoLocationSearchVisible = true"
          >
            <img class="mr-2" :src="require('@/assets/ico-minus.svg')" alt="" />
            Vyloučit další místo
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </v-sheet>
</template>

<script>
import { call, sync } from "vuex-pathify"

import GeoLocationInput from "@/components/ui/targeting/GeoLocationInput"
import GeoLocationType from "@/components/ui/targeting/GeoLocationType"
import GeoLocationSearch from "@/components/ui/targeting/GeoLocationSearch"

export default {
  name: "GeoLocations",
  components: {
    GeoLocationInput,
    GeoLocationType,
    GeoLocationSearch,
  },
  props: {
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      excludedGeoLocationVisible: false,
      excludedGeoLocationSearchVisible: false,
      geoLocationSearchVisible: false,
      minAge: 18,
      maxAge: 65,
    }
  },
  methods: {
    onExcludedGeoLocationSearchDelete() {
      this.excludedGeoLocationSearchVisible = false
    },
    onExcludedGeoLocationSearchSelect(val) {
      this.excludedGeoLocationSearchVisible = false

      this.excludedGeoLocationAppend(val)
    },
    onGeoLocationSearchDelete() {
      this.geoLocationSearchVisible = false
    },
    onGeoLocationSearchSelect(val) {
      this.geoLocationSearchVisible = false

      this.geoLocationAppend(val)
    },
    onGeoLocationsTypesChange(val) {
      this.geoLocationsTypes = val
    },
  },
  mounted() {
    if (!this.excludedGeoLocationVisible) {
      this.excludedGeoLocationVisible = !!this.excludedGeoLocations.length
    }

    this.excludedGeoLocationSearchVisible = !this.excludedGeoLocations.length
    this.geoLocationSearchVisible = !this.geoLocations.length
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }
    if (!this.$options.methods) {
      this.$options.methods = {}
    }

    Object.assign(this.$options.computed, {
      ...sync(`${storeNamespace}/model@audience.targeting`, [
        "excludedGeoLocations",
        "excludedGeoLocationsTypes",
        "geoLocations",
        "geoLocationsTypes",
      ]),
    })

    Object.assign(this.$options.methods, {
      ...call(`${storeNamespace}`, [
        "excludedGeoLocationAppend",
        "excludedGeoLocationRemove",
        "excludedGeoLocationUpdate",
        "geoLocationAppend",
        "geoLocationRemove",
        "geoLocationUpdate",
      ]),
    })
  },
}
</script>
